module.exports = __webpack_public_path__ + "img/79b8844574920557a9a5db3ced3b2a0a.png";